<div class="sidebar-nav">
	<ul class="list-unstyled">
		<li class=""> <a class="p-2 text-body" routerLink="/settings/organization" routerLinkActive="active">Organization
				details</a></li>
		<!-- <li class=""> <a class="p-2 text-body" routerLink="/settings/audit-logs" routerLinkActive="active">Audit logs</a></li> -->
		<li class=""> <a class="p-2 text-body" routerLink="/settings/users" routerLinkActive="active">Manage users</a></li>
		<li class=""> <a class="p-2 text-body" routerLink="/settings/programs" routerLinkActive="active">Programs</a></li>
		<li class=""> <a class="p-2 text-body" routerLink="/settings/commission-plans" routerLinkActive="active">Commission
				plans</a></li>
		<li class=""> <a class="p-2 text-body" routerLink="/settings/issued-cards" routerLinkActive="active">Issued
				cards</a></li>
		<li class=""> <a class="p-2 text-body" routerLink="/settings/bank-accounts" routerLinkActive="active">Bank
				accounts</a></li>
		<li class=""> <a class="p-2 text-body" routerLink="/settings/webhooks" routerLinkActive="active">Webhooks</a></li>
		<li class=""> <a class="p-2 text-body" routerLink="/settings/api-token" routerLinkActive="active">API token</a></li>
		<li class=""> <a class="p-2 text-body" routerLink="/settings/integration" routerLinkActive="active">Integration</a></li>
		<li class=""> <a class="p-2 text-body" routerLink="/settings/billing" routerLinkActive="active">Billing</a></li>
	</ul>
</div>